import React from 'react'
export default class SCR extends React.Component{
  static resizeParent(options){
    var height = document.getElementsByTagName("html")[0].offsetHeight;
    //console.log(height)
    window.parent.postMessage(["setHeight", height], "*");
  }
  static prettyDate(d){
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    var newDate = new Date(Date.parse(d));
    if(newDate.getDate !== 'function')
      return days[newDate.getDay()] + ', ' + monthNames[newDate.getMonth()] + ' ' + newDate.getDate() + ', ' + newDate.getFullYear();
    else
      return "";
  }

  static getCity(code){
    var city = {
      NIS : 'Savannah',
      HINES : 'Hinesville',
      STATES : 'Statesboro'
    };

    return city[code];
  }

  static fixDateString(str){
    if(typeof str === "undefined" || str === '')
      return '';

    var parts = str.split(' ');

    var dt = parseInt(parts[0].substring(0, 2)) + '/' + parseInt(parts[0].substring(2, 4)) + '/' + parseInt(parts[0].substring(4, 8));
    return dt + ' ' + parts[1] + ' ' + parts[2];
  }

  static fireTracking(page, options){
    if (typeof window !== "undefined") {
      console.log('fire tracking for page ' + page)

      // facebook tracking
      if(page === '/thankyou')
        window.parent.postMessage(['fireResConfirmationTracking', ''], "*");
      else if(page === '/lookup')
        window.parent.postMessage(['fireLookupTracking', ''], "*");

      /*if (window.fbq != null){
        //alert('fb pageview')
        window.fbq('track', 'PageView');
      }*/
        //window.fbq('trackSingleCustom', '609453454107810', 'PageView',{});

      if(window.gtag != null){
        window.gtag('set', 'page_path', page);
        if(typeof options.confirmationCode !== 'undefined')
          window.gtag('set', 'dimension1', options.confirmationCode);
        window.gtag('event', 'page_view');
        //window.gtag('config', 'UA-12341353-18');
      }
    }
  }
}
